module.exports = __webpack_public_path__ + "img/nin2.9da43be6.png";